import React from 'react';
import LoadingSpinner from './LoadingSpinner';

/**
 * PageLoader - Full page loading component
 * @param {string} text - Loading text (default: 'Loading...')
 * @param {string} className - Additional CSS classes
 */
const PageLoader = ({ text = 'Loading...', className = '' }) => {
  return (
    <div className={`page-loader ${className}`}>
      <div className="page-loader-content">
        <LoadingSpinner size="lg" color="primary" />
        {text && <p className="page-loader-text">{text}</p>}
      </div>
    </div>
  );
};

export default PageLoader;
